module.exports = __webpack_public_path__ + "static/franchise-aa16a4f28f50a3190e07382f9ced91e8.png";